export interface NavLink {
  label: string;
  href: string;
}

export const navLinks: NavLink[] = [
  { label: "首页", href: "#home" },
  { label: "热搜风向", href: "#hot" },
  { label: "热议话题", href: "#topics" },
  { label: "网友热评", href: "#comments" },
  { label: "围观广场", href: "#browse" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export interface Platform {
  name: string;
  desc: string;
  count: string;
  icon: string;
  color: string;
}

export const platforms: Platform[] = [
  { name: "贴吧热帖", desc: "吧友盖楼讨论前线，最新风向一手掌握", count: "2.4w+ 条热帖", icon: "ri-wechat-fill", color: "bg-primary-50 text-primary-600" },
  { name: "知乎问答", desc: "高赞理性分析，深挖话题背后的来龙去脉", count: "8600+ 个回答", icon: "ri-question-answer-fill", color: "bg-accent-50 text-accent-600" },
  { name: "论坛热榜", desc: "各路网友观点交锋，看热闹也看门道", count: "1.1w+ 条热评", icon: "ri-chat-3-fill", color: "bg-secondary-100 text-secondary-700" },
  { name: "热搜追踪", desc: "各大榜单实时汇总，吃瓜不遗漏关键节点", count: "120+ 个话题", icon: "ri-fire-fill", color: "bg-primary-50 text-primary-500" },
];

export interface HotItem {
  rank: number;
  title: string;
  heat: string;
  trend: "up" | "down" | "new" | "keep";
  platform: string;
}

export const hotList: HotItem[] = [
  { rank: 1, title: "娜娜51 新一季内容企划曝光，网友集体期待", heat: "986万", trend: "up", platform: "贴吧" },
  { rank: 2, title: "「现场直击」娜娜51 线下互动会返图合集", heat: "742万", trend: "new", platform: "热搜" },
  { rank: 3, title: "理性讨论：为什么娜娜51 的评论区永远那么热闹", heat: "615万", trend: "up", platform: "知乎" },
  { rank: 4, title: "娜娜51 早期作品考古现场，老粉集体破防", heat: "528万", trend: "keep", platform: "论坛" },
  { rank: 5, title: "盘点娜娜51 十大名场面，每一个都值得二刷", heat: "463万", trend: "up", platform: "贴吧" },
  { rank: 6, title: "娜娜51 回应节奏质疑，态度获大量网友认可", heat: "398万", trend: "down", platform: "知乎" },
  { rank: 7, title: "「围观」娜娜51 粉丝二创大赛结果新鲜出炉", heat: "351万", trend: "new", platform: "论坛" },
  { rank: 8, title: "从路人到真香：娜娜51 圈粉的完整心路历程", heat: "286万", trend: "keep", platform: "热搜" },
  { rank: 9, title: "娜娜51 幕后团队访谈：我们是这样做内容的", heat: "219万", trend: "up", platform: "知乎" },
  { rank: 10, title: "冷静吃瓜：热议背后那些值得思考的点", heat: "183万", trend: "down", platform: "贴吧" },
];

export interface Category {
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { name: "全部热议", icon: "ri-apps-2-line" },
  { name: "名场面", icon: "ri-clapperboard-line" },
  { name: "圈粉故事", icon: "ri-heart-line" },
  { name: "线下互动", icon: "ri-camera-lens-line" },
  { name: "理性讨论", icon: "ri-discuss-line" },
  { name: "考古回放", icon: "ri-history-line" },
  { name: "二创狂欢", icon: "ri-palette-line" },
];

export interface Topic {
  id: number;
  title: string;
  category: string;
  summary: string;
  heat: string;
  comments: number;
  time: string;
  platform: string;
  sourceIcon: string;
  image: string;
  tags: string[];
}

export const topics: Topic[] = [
  {
    id: 1,
    title: "娜娜51 新企划首曝，网友直呼「这波有料」",
    category: "名场面",
    summary: "围绕娜娜51 最新内容企划的讨论在多个平台同步发酵，吧友、网友与知乎答主从不同角度展开解读，评论区金句频出，热度持续走高。",
    heat: "968万",
    comments: 4823,
    time: "2 小时前",
    platform: "贴吧",
    sourceIcon: "ri-wechat-fill",
    image: "https://readdy.ai/api/search-image?query=warm%20flat%20illustration%20of%20people%20chatting%20around%20glowing%20coral%20topic%20bubbles%2C%20cream%20and%20amber%20background%2C%20modern%20minimal%20vector%20art%2C%20soft%20shadows%2C%20energetic%20community%20vibe&width=800&height=560&seq=topic-01&orientation=landscape",
    tags: ["企划首曝", "风向标", "吧友热议"],
  },
  {
    id: 2,
    title: "理性讨论：娜娜51 评论区为何总在「前排集合」",
    category: "理性讨论",
    summary: "知乎高赞分析帖把娜娜51 的内容节奏、互动习惯和粉丝生态逐一拆解，从路人到忠粉的转变路径被讲得明明白白，引发大量转载与补充评论。",
    heat: "762万",
    comments: 3910,
    time: "5 小时前",
    platform: "知乎",
    sourceIcon: "ri-question-answer-fill",
    image: "https://readdy.ai/api/search-image?query=warm%20minimal%20illustration%20of%20a%20magnifier%20over%20chat%20speech%20bubbles%2C%20amber%20and%20coral%20accents%20on%20cream%20paper%20background%2C%20modern%20flat%20vector%2C%20thoughtful%20analysis%20mood&width=800&height=560&seq=topic-02&orientation=landscape",
    tags: ["知乎高赞", "理性分析", "粉丝生态"],
  },
  {
    id: 3,
    title: "线下互动会返图合集，现场氛围直接拉满",
    category: "线下互动",
    summary: "一组娜娜51 线下互动会的现场返图与实拍在论坛引发刷屏，热心网友纷纷晒出自己的「前线视角」，互动细节与幕后花絮看点十足。",
    heat: "584万",
    comments: 2708,
    time: "昨天 21:30",
    platform: "论坛",
    sourceIcon: "ri-chat-3-fill",
    image: "https://readdy.ai/api/search-image?query=warm%20illustration%20of%20a%20stage%20with%20cheering%20crowd%20holding%20phones%20and%20glow%20sticks%2C%20coral%20amber%20cream%20palette%2C%20modern%20flat%20vector%20style%2C%20lively%20concert%20atmosphere&width=800&height=560&seq=topic-03&orientation=landscape",
    tags: ["线下直击", "返图", "现场氛围"],
  },
  {
    id: 4,
    title: "考古回放：娜娜51 早期的那些「青涩名场面」",
    category: "考古回放",
    summary: "老粉们自发开启的考古行动热度不减，娜娜51 早期作品的珍贵片段被逐一整理，当年的「青涩瞬间」让不少人直呼反差感太强。",
    heat: "421万",
    comments: 1866,
    time: "昨天 14:10",
    platform: "贴吧",
    sourceIcon: "ri-wechat-fill",
    image: "https://readdy.ai/api/search-image?query=warm%20retro%20illustration%20of%20a%20film%20reel%20and%20polaroid%20photos%2C%20vintage%20amber%20and%20cream%20tones%2C%20modern%20flat%20vector%2C%20nostalgic%20archaeology%20mood&width=800&height=560&seq=topic-04&orientation=landscape",
    tags: ["考古", "老粉", "反差感"],
  },
  {
    id: 5,
    title: "粉丝二创大赛结果揭晓，网友脑洞大开",
    category: "二创狂欢",
    summary: "围绕娜娜51 展开的二创作品大赛落下帷幕，插画、视频、音乐改编层出不穷，获奖作品的创意与用心程度获得一片好评。",
    heat: "352万",
    comments: 1420,
    time: "昨天 10:00",
    platform: "论坛",
    sourceIcon: "ri-palette-line",
    image: "https://readdy.ai/api/search-image?query=colorful%20warm%20illustration%20of%20paint%20brushes%2C%20palette%20and%20creative%20sparkles%20and%20art%20tools%2C%20coral%20amber%20cream%20flat%20vector%2C%20joyful%20fan%20creation%20contest&width=800&height=560&seq=topic-05&orientation=landscape",
    tags: ["二创", "插画", "脑洞"],
  },
  {
    id: 6,
    title: "幕后团队访谈：好内容究竟是怎么做出来的",
    category: "圈粉故事",
    summary: "一次难得的幕后访谈把娜娜51 的内容生产流程摊开来讲，创作初心、选题逻辑与粉丝沟通方式都聊得很透，读完更有「路转粉」冲动。",
    heat: "298万",
    comments: 1130,
    time: "昨天 08:20",
    platform: "知乎",
    sourceIcon: "ri-question-answer-fill",
    image: "https://readdy.ai/api/search-image?query=warm%20illustration%20of%20a%20small%20studio%20desk%20with%20laptop%20camera%20and%20scripts%2C%20cozy%20cream%20amber%20coral%20flat%20vector%2C%20behind%20the%20scenes%20interview%20mood&width=800&height=560&seq=topic-06&orientation=landscape",
    tags: ["幕后访谈", "创作初心", "圈粉"],
  },
  {
    id: 7,
    title: "从路人到真香：这届网友的「入坑」实录",
    category: "圈粉故事",
    summary: "一篇篇「入坑实录」在热搜悄然走红，从无感到上头的过程被写得真实又好笑，评论区秒变大型真香现场。",
    heat: "255万",
    comments: 980,
    time: "前天 22:40",
    platform: "热搜",
    sourceIcon: "ri-fire-fill",
    image: "https://readdy.ai/api/search-image?query=warm%20illustration%20of%20a%20journey%20path%20with%20footprints%20leading%20to%20a%20glowing%20heart%2C%20coral%20amber%20cream%20flat%20vector%2C%20fan%20conversion%20story%20mood&width=800&height=560&seq=topic-07&orientation=landscape",
    tags: ["入坑实录", "真香", "路转粉"],
  },
  {
    id: 8,
    title: "冷静吃瓜：热议之下，我们该关注什么",
    category: "理性讨论",
    summary: "在一片热闹中，也有人提醒大家理性围观、友好讨论。这条帖子被广泛转发，观点温和而有力量，值得每位吃瓜网友一读。",
    heat: "196万",
    comments: 760,
    time: "前天 19:15",
    platform: "贴吧",
    sourceIcon: "ri-wechat-fill",
    image: "https://readdy.ai/api/search-image?query=calm%20warm%20illustration%20of%20balance%20scales%20with%20speech%20bubbles%20and%20soft%20light%2C%20cream%20amber%20subtle%20coral%20flat%20vector%2C%20peaceful%20rational%20discussion%20mood&width=800&height=560&seq=topic-08&orientation=landscape",
    tags: ["理性围观", "友好讨论", "吃瓜礼仪"],
  },
];

export interface Comment {
  id: number;
  user: string;
  role: string;
  time: string;
  platform: string;
  content: string;
  likes: string;
  tag: string;
  color: string;
}

export const comments: Comment[] = [
  {
    id: 1,
    user: "今天也要吃瓜",
    role: "资深吧友",
    time: "3 小时前",
    platform: "贴吧",
    content: "新企划的预告我看了三遍，细节真的诚意满满，评论区已经开始提前过年了哈哈哈，蹲一个正式上线。",
    likes: "1.2w",
    tag: "前排热评",
    color: "bg-primary-500",
  },
  {
    id: 2,
    user: "理性观察员",
    role: "知乎答主",
    time: "5 小时前",
    platform: "知乎",
    content: "抛开热闹本身，娜娜51 的内容节奏确实有值得学习的地方：选题贴近大众、更新稳定、互动走心。理性分析，欢迎补充。",
    likes: "8900",
    tag: "高赞回答",
    color: "bg-accent-500",
  },
  {
    id: 3,
    user: "考古队长",
    role: "论坛常客",
    time: "昨天",
    platform: "论坛",
    content: "把早期视频翻了个遍，那种青涩又真诚的感觉太有感染力了，怪不得能圈住这么多老粉，考古真的会上头。",
    likes: "6500",
    tag: "热评",
    color: "bg-secondary-500",
  },
  {
    id: 4,
    user: "北方的南瓜",
    role: "新粉",
    time: "昨天",
    platform: "知乎",
    content: "作为一个刚入坑的路人，翻了很久的讨论，感觉这里的氛围比想象中友好很多，大家各有观点但都在好好说话。",
    likes: "4300",
    tag: "入坑实录",
    color: "bg-primary-400",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: "娜娜51贴吧热议圈是什么类型的网站？",
    a: "娜娜51贴吧热议圈是一站式的网络热点内容聚合社区，围绕「娜娜51」相关话题，把贴吧热帖、知乎问答、论坛热榜与热搜动态集中到一起，方便网友快速围观各路观点与讨论精华。",
  },
  {
    q: "我可以在网站上发布自己的观点吗？",
    a: "当然可以。欢迎通过页面底部的「提交话题 / 反馈建议」表单告诉我们你的想法或发现的热点，我们会在核实内容与表达规范后择优收录进相关话题区，让更多网友看到你的声音。",
  },
  {
    q: "网站上的内容来自哪里？",
    a: "内容主要来自各大公开社区与平台的网友公开讨论，我们在尊重原创的前提下进行整理、归类与摘要，并尽量保留原平台出处与热度参考，方便你顺藤摸瓜查看原帖。",
  },
  {
    q: "如何确保讨论环境的理性与友好？",
    a: "我们推崇理性围观与友好表达，坚持不传谣、不攻击、尊重隐私的原则。如果发现不当内容，可在表单中说明并提交，我们会尽快核实处理，一起守护健康的吃瓜氛围。",
  },
  {
    q: "网站是免费使用的吗？",
    a: "是的，娜娜51贴吧热议圈面向所有网友免费开放，无需注册即可浏览全部话题与讨论。我们也承诺不收集与话题浏览无关的隐私信息。",
  },
];

export interface Stat {
  value: string;
  label: string;
}

export const stats: Stat[] = [
  { value: "300万+", label: "累计围观" },
  { value: "1200+", label: "收录话题" },
  { value: "4", label: "平台聚合" },
  { value: "24h", label: "持续更新" },
];

export interface Reputation {
  user: string;
  text: string;
  tag: string;
}

export const reputationList: Reputation[] = [
  { user: "老用户·阿澈", text: "每天上来刷一圈，话题整理得清清楚楚，省得我满平台找瓜吃，已经很习惯这种节奏了。", tag: "话题整理" },
  { user: "新朋友·小满", text: "第一次来就能看懂来龙去脉，导航很清晰，评论区氛围也好，一下就路转粉了。", tag: "上手友好" },
  { user: "潜水员·Leo", text: "不注册也能全看，这点很加分。内容更新稳定，理性讨论的比例比我预想高很多。", tag: "更新稳定" },
];